<div class="page">

  <div class="pagehead">
    <div>
      <h1>Merchant certificate</h1>
      <p>Your EasyRin merchant certificate — print it and display it at your counter</p>
    </div>
  </div>

  <div class="row-2-1">
    <div class="card form-card">
      <div class="clabel"><svg viewBox="0 0 24 24"><circle cx="12" cy="9" r="5"/><path d="M9 13l-2 8 5-3 5 3-2-8"/></svg>Download certificate</div>
      <p class="cert-copy">The certificate carries your merchant details and confirms you're an authorised EasyRin retail point.</p>
      <div class="form-actions form-actions--start">
        <button type="button" class="er-btn er-btn--primary" (click)="downloadCertificate()">
          <i class="fa fa-download" aria-hidden="true"></i>&nbsp;Download certificate
        </button>
      </div>
    </div>

    <div class="card art-card">
      <img src="../../assets/images/undraw_certificate_re_yadi.svg" alt="" class="art">
    </div>
  </div>

</div>
